import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
// import { clearInterval } from 'timers';

@Component({
  selector: 'app-keep-alive-dialog',
  templateUrl: './keep-alive-dialog.component.html',
  styleUrls: ['./keep-alive-dialog.component.scss']
})
export class KeepAliveDialogComponent implements OnInit {
  timeout = environment.timeoutMinutes;

  sessionsToDone = 60;

  constructor(
    public dialogRef: MatDialogRef<KeepAliveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  afterClosed() {
    if (this.myInterval) clearInterval(this.myInterval);
  }

  myInterval;
  ngOnInit() {
    this.myInterval = setInterval(value => {
      if (this.sessionsToDone-- < 0) {
        clearInterval(this.myInterval);
        window.location.href = environment.logoutURL;
      }
    }, 1000);
  }
}
